module.exports = __webpack_public_path__ + "img/WeStore_logo-white-footer-w208.9e187585.png";